import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { AnalyticsCards } from "Common/Components/AnalyticsCards/AnalyticsCards";
import { defaultInnerStyle } from "Common/Components/PageContainer/PageContainer";
import { ClipboardList, FileCheck, Clock } from "lucide-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import OrderPaymentListing from "./OrderPayment/OrderPaymentListing";
import RetentionPaymentListing from "./RetentionPayment/RetentionPaymentListing";
import PBGListing from "./PGB/PBGListing";
import { clearAllTableStates } from "utils/clearTableStates";

const PaymentManagementProductListing = () => {
  const [tab, setTab] = useState(
    Number(sessionStorage?.getItem("PaymentManagementProductListingTab")) || 1
  );

  const handleTabChange = useCallback(
    (_event: React.SyntheticEvent, newValue: number) => {
      const newTab = newValue + 1;
      setTab(newTab);
      clearAllTableStates();
      sessionStorage.setItem(
        "PaymentManagementProductListingTab",
        newTab.toString()
      );
    },
    []
  );

  const statuses = useMemo(
    () => [
      {
        label: "Order Payments",
        icon: <ClipboardList size={16} />,
        bgColor: "bg-blue-50",
        textColor: "text-blue-600",
        count: 0,
      },
      {
        label: "Retention",
        icon: <Clock size={16} />,
        bgColor: "bg-yellow-50",
        textColor: "text-yellow-600",
        count: 0,
      },
      {
        label: "PBG",
        icon: <FileCheck size={16} />,
        bgColor: "bg-green-50",
        textColor: "text-green-600",
        count: 0,
      },
    ],
    []
  );

  useEffect(() => {
    return () => {
      if (!window.location.pathname.startsWith("/payment-management")) {
        sessionStorage.removeItem("PaymentManagementProductListingTab");
      }
    };
  }, []);

  return (
    <div
      className="page-content px-3 mecord-kpi-list-page"
      style={{ "--mecord-table-offset": "380px" } as React.CSSProperties}
    >
      <div className="flex-shrink-0">
        <AnalyticsCards statuses={statuses} />
      </div>

      <div
        className="mecord-list-panel"
        style={{
          ...defaultInnerStyle,
          flex: "1 1 0",
          maxHeight: "100%",
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="flex-shrink-0">
          <div className="mecord-toolbar-title">
            <h6>Sales Payment Management</h6>
          </div>

          <div className="mecord-tabs-wrap">
            <Box sx={{ width: "100%" }}>
              <Tabs
                value={tab - 1}
                onChange={handleTabChange}
                sx={{
                  minHeight: 30,
                  "& .MuiTab-root": {
                    fontFamily: "'Poppins', sans-serif",
                    textTransform: "none",
                    color: "#555555",
                    minHeight: 30,
                    paddingTop: "2px",
                    paddingBottom: "2px",
                    transition: "color 0.2s ease",
                  },
                  "& .MuiTab-root:hover": {
                    color: "#d2363a",
                  },
                  "& .Mui-selected": {
                    color: "#d2363a !important",
                  },
                  "& .MuiTabs-indicator": {
                    backgroundColor: "#d2363a",
                    height: "3px",
                    transition: "all 0.3s ease",
                  },
                }}
              >
                <Tab label="Sales Order Payment" />
                <Tab label="Retention Payment" />
                <Tab label="PBG" />
              </Tabs>
              <Divider sx={{ mt: 0, borderColor: "#c35f61" }} />
            </Box>
          </div>
        </div>

        <div
          className="d-flex flex-column"
          style={{
            flex: "1 1 auto",
            minHeight: 0,
            maxHeight: "100%",
            overflow: "hidden",
          }}
        >
          {tab === 1 ? (
            <OrderPaymentListing activeTab="Sales Order Payment" />
          ) : tab === 2 ? (
            <RetentionPaymentListing activeTab="Retention Payment" />
          ) : tab === 3 ? (
            <PBGListing activeTab="PBG" />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PaymentManagementProductListing;
